// TypingIndicator.js
import React from 'react';
import './TypingIndicator.css'; // You'll need to create this CSS file

const TypingIndicator = () => (
  <div className="typing-indicator">
    <span></span>
    <span></span>
    <span></span>
  </div>
);

export default TypingIndicator;